"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATEVALUE = void 0;
exports.DATEVALUE = {
    alias: 'VALOR_DATA',
    description: 'Converte um texto em uma data válida.',
    arg_names: ['data', 'formato', 'idioma'],
    args_description: ['data em texto', 'formato do texto(ex: dd/mm/yyyy)', 'idioma a ser usado'],
};
